import React from "react";

function Paragraph({ children }) {
  return <p className="tcf-paragraph">{children}</p>;
}

export default Paragraph;
